export const PROTECTED_ROUTES = ['/checkout', '/order-confirmation']

export const LEGAL_AGE_BY_PROVINCE = {
  AB: 18,
  BC: 19,
  MB: 18,
  NB: 19,
  NL: 19,
  NT: 18,
  NS: 19,
  NU: 19,
  ON: 19,
  PE: 21,
  QC: 18,
  SK: 18,
  YT: 19
}

export const CART_SUMMARY_HEIGHT_MOBILE = '78px'
export const CART_SUMMARY_HEIGHT_DESKTOP = '130px'

export const TOAST_DURATION_MS = 3000

export const ACCESSORIES = {
  'vype-epod-vape': {
    handle: 'epod-accessories',
    skins: true
  },
  'vype-epen-3': {
    handle: '',
    skins: false
  }
}

export const CARTRIDGES = {
  'vype-epod-vpro-cartridges': {
    title: 'ePOD',
    pageHandle: 'vype-epod-vpro-cartridges'
  },
  'vype-epod-vape': {
    handle: 'vype-epod-vpro-cartridges',
    packName: '2 cartridges',
    tabs: [
      {
        name: 'vPro',
        handle: ''
      }
    ]
  }
}

export const EPEN_CARTRIDGES_SKUS = [
  '10097597',
  '10097587',
  '10097613',
  '10093982',
  '10097641',
  '10068960',
  '10093903',
  '10093933',
  '10093961',
  '10097593',
  '10097588',
  '10097624',
  '10097612',
  '10097605',
  '10069164',
  '10097508',
  '10097480',
  '10068966',
  '10097507',
  '10097642',
  '10069146',
  '10097439',
  '10097623',
  '10069129'
]

export const STORE_LOCATOR_OPTIONS = {
  logo: 'https://cdn.shopify.com/s/files/1/2727/5392/files/logo.png?12776652579441201003',
  name: 'vype',
  colors: {
    primary: '#16191c',
    secondary: '#EE3840'
  }
}

export const SLIDESHOW_SPEED = '700ms'

export const SWATCH_COLOR_FOR_OPTION_NAME = {
  red: '#D72A3D',
  blue: '#407896',
  purple: '#4b4271',
  gold: 'linear-gradient(90deg, #746B5C 12.5%, #D6BE9C 95.83%)',
  black: 'linear-gradient(90deg, #000000 12.5%, #3A3A3A 95.83%)',
  chrome: '#92949A',
  white: '#FFFFFF',
  graphite: 'linear-gradient(90deg, #4D4D4D 12.5%, #989898 95.83%)',
  'rose gold': 'linear-gradient(90deg, #625251 12.5%, #E7B8B0 95.83%)',
  matblack: '#a2acab',
  silver: 'linear-gradient(90deg, #61666F 12.5%, #D4D7DF 95.83%)',
  aqua: '#3B9B94',
  pink: '#D893B6',
  green: '#7B9164',
  yellow: '#EBAD06',
  orange: '#E25830',
  turquoise: '#3A9FA2',
  '50hz - black': '#000',
  '50hz - graphite': '#6f746f',
  '50hz - rose gold': '#f5c9c0',
  '1728hz - black': '#000',
  '1728hz - graphite': '#6f746f',
  '1728hz - rose gold': '#f5c9c0',
  '1453hz - black': '#000',
  '1453hz - graphite': '#6f746f',
  '1453hz - rose gold': '#f5c9c0'
}

export const SETTINGS_FOR_PRODUCT_NAME = {
  lychee: {
    gradient: 'linear-gradient(110.85deg, #C13930 -7.61%, #B33C36 115.55%), #DE4448',
    name: 'Lychee',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 5
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  passionfruit: {
    name: 'Passionfruit',
    gradient: 'linear-gradient(110.85deg, #7B2783 -7.61%, #551E53 115.55%), #A55199',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 5
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'infused-cucumber': {
    gradient: 'linear-gradient(110.85deg, #589B75 -7.61%, #023A1A 113.2%), #67A481',
    name: 'Cucumber',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'infused-cucumber-epod-cartridge': {
    gradient: 'linear-gradient(110.85deg, #589B75 -7.61%, #023A1A 113.2%), #67A481',
    name: 'Cucumber',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'garden-strawberry-epod-cartridge': {
    gradient: 'linear-gradient(110.85deg, #DF525C -7.61%, #A4101C 115.55%), #DD0C34',
    name: 'Strawberry',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'mango-wonder-epod-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #DBA700 -7.61%, #9C6E00 115.55%), #DEAA04',
    name: 'Mango',
    refillsTag: 'New & Improved',
    productPageTag: 'New & Improved',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'epod-mango-wonder-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #DBA700 -7.61%, #9C6E00 115.55%), #DEAA04',
    name: 'Mango',
    refillsTag: 'New & Improved',
    productPageTag: 'New & Improved',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'tobacco-marvel-epod-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #D18F0E -7.61%, #543000 115.55%), #B47908',
    name: 'Golden Tobacco',
    refillsTag: 'Zero Nic Available',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'epod-nicotine-salts-golden-tobacco-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #D18F0E -7.61%, #543000 115.55%), #B47908',
    name: 'Golden Tobacco',
    refillsTag: 'Zero Nic Available',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'smooth-tobacco': {
    gradient: 'linear-gradient(160.31deg, #D6AB71 -25.73%, #492A21 110.6%), #CDA16A',
    name: 'Smooth Tobacco',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 2
      }
    ],
    ontarioTag: 'New'
  },
  'aromatic-tobacco': {
    gradient: 'linear-gradient(113.38deg, #B69552 -13.34%, #362811 116.6%), #7E5F2C',
    name: 'Aromatic Tobacco',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 4
      }
    ],
    ontarioTag: 'New'
  },
  'rich-tobacco': {
    gradient: 'linear-gradient(109.83deg, #A0784E -22.45%, #3E271E 108.62%), #3D221C',
    name: 'Rich Tobacco',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 5
      },
      {
        label: 'Complexity',
        value: 5
      },
      {
        label: 'Round Body',
        value: 5
      }
    ],
    ontarioTag: 'New'
  },
  peppermint: {
    gradient: 'linear-gradient(109.05deg, #008066 -14.41%, #004031 107.54%), #007B62',
    name: 'Cool Peppermint',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 4
      }
    ],
    ontarioTag: 'New'
  },
  'creamy-mint': {
    gradient: 'linear-gradient(107.58deg, #86C9B8 -20.31%, #3F886C 105.96%), #77BCA4',
    name: 'Smooth Mint',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 3
      },
      {
        label: 'Round Body',
        value: 5
      }
    ],
    ontarioTag: 'New'
  },
  peach: {
    gradient: 'linear-gradient(108.77deg, #E9684D -7.61%, #BB321B 113.2%), #EE7A5F',
    name: 'Peach',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 3
      },
      {
        label: 'Round Body',
        value: 4
      }
    ],
    ontarioTag: 'New'
  },
  'vanilla-medley-epod-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #CA9957 -7.61%, #725628 113.2%), #9B7438',
    name: 'Vanilla',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'epod-nicotine-salts-vanilla': {
    gradient: 'linear-gradient(110.85deg, #CA9957 -7.61%, #725628 113.2%), #9B7438',
    name: 'Vanilla',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'epen-3-cartridge-infused-vanilla': {
    gradient: 'linear-gradient(110.85deg, #CA9957 -7.61%, #725628 113.2%), #9B7438',
    name: 'Vanilla'
  },
  'polar-mint-epod-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #5D9892 -7.61%, #0B3C37 115.55%), #073833',
    name: 'Polar Mint',
    refillsTag: 'Zero Nic Available',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'epod-vpro-cartridges-polar-mint': {
    gradient: 'linear-gradient(110.85deg, #5D9892 -7.61%, #0B3C37 115.55%), #073833',
    name: 'Polar Mint',
    refillsTag: 'Zero Nic Available',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'crisp-mint-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #5D9892 -7.61%, #0B3C37 115.55%), #073833',
    name: 'Crisp Mint'
  },
  'crushed-mint-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #5D9892 -7.61%, #0B3C37 115.55%), #073833',
    name: 'Crisp Mint'
  },
  'berry-blast-epod-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #B15B6B -7.61%, #8D2E41 115.55%), #5F1221',
    name: 'Berry',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'vype-pods-berry-blast-epod-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #B15B6B -7.61%, #8D2E41 115.55%), #5F1221',
    name: 'Berry',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'berry-blast': {
    gradient: 'linear-gradient(110.85deg, #B15B6B -7.61%, #8D2E41 115.55%), #5F1221',
    name: 'Berry',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  strawberry: {
    gradient: 'linear-gradient(110.85deg, #DF525C -7.61%, #A4101C 115.55%), #DD0C34',
    name: 'Strawberry',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 4
      }
    ]
  },
  'original-strawberry-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #DF525C -7.61%, #A4101C 115.55%), #DD0C34',
    name: 'Strawberry'
  },
  'blood-orange': {
    gradient: 'linear-gradient(110.85deg, #EC6A4C -7.61%, #B33C36 115.55%), #E5995B',
    name: 'Blood Orange',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'blood-orange-epod-cartridge': {
    gradient: 'linear-gradient(110.85deg, #EC6A4C -7.61%, #B33C36 115.55%), #E5995B',
    name: 'Blood Orange',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 2
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'classic-tobacco-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #D5783E -7.61%, #934924 115.55%), #934924',
    name: 'Classic Tobacco'
  },
  'discovery-pack-epen-3-vpro-cartridges': {
    gradient: 'linear-gradient(110.85deg, #222 -7.61%, #333 115.55%), #333',
    name: 'Discovery'
  },
  'fresh-apple-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #7AA85A -7.61%, #295924 113.2%), #C0D994',
    name: 'Apple'
  },
  'vype-epen3-pods-fresh-apple-cartridge': {
    gradient: 'linear-gradient(110.85deg, #7AA85A -7.61%, #295924 113.2%), #C0D994',
    name: 'Apple'
  },
  'fresh-apple-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #7AA85A -7.61%, #295924 113.2%), #C0D994',
    name: 'Apple'
  },
  'infused-vanilla-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #CA9957 -7.61%, #725628 113.2%), #9B7438',
    name: 'Vanilla'
  },
  'infused-vanilla-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #CA9957 -7.61%, #725628 113.2%), #9B7438',
    name: 'Vanilla'
  },
  'dark-cherry-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #AD2E72 -7.61%, #5C143A 115.55%), #A55199',
    name: 'Cherry'
  },
  'vype-epen3-dark-cherry-cartridge': {
    gradient: 'linear-gradient(110.85deg, #AD2E72 -7.61%, #5C143A 115.55%), #A55199',
    name: 'Cherry'
  },
  'dark-cherry-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #AD2E72 -7.61%, #5C143A 115.55%), #A55199',
    name: 'Cherry'
  },
  'strawberry-smash-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #DF525C -7.61%, #A4101C 115.55%), #DD0C34',
    name: 'Strawberry'
  },
  'epen-3-vape-pods-strawberry-smash': {
    gradient: 'linear-gradient(110.85deg, #DF525C -7.61%, #A4101C 115.55%), #DD0C34',
    name: 'Strawberry'
  },
  'blended-tobacco-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #D18F0E -7.61%, #543000 115.55%), #B47908',
    name: 'Classic Tobacco'
  },
  'golden-tobacco-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #D18F0E -7.61%, #543000 115.55%), #B47908',
    name: 'Classic Tobacco'
  },
  'epen-3-golden-tobacco-cartridge': {
    gradient: 'linear-gradient(110.85deg, #D18F0E -7.61%, #543000 115.55%), #B47908',
    name: 'Classic Tobacco'
  },
  'crushed-mint-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #5D9892 -7.61%, #0B3C37 115.55%), #073833',
    name: 'Crisp Mint'
  },
  'vape-pods-crushed-mint-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #5D9892 -7.61%, #0B3C37 115.55%), #073833',
    name: 'Crisp Mint'
  },
  'classic-peach-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #E9684D -7.61%, #BB321B 113.2%), #EE7A5F',
    name: 'Peach'
  },
  'classic-peach-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #E9684D -7.61%, #BB321B 113.2%), #EE7A5F',
    name: 'Peach'
  },
  'peach-whirl-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #E9684D -7.61%, #BB321B 113.2%), #EE7A5F',
    name: 'Peach'
  },
  'epen-3-cartridge-peach-whirl': {
    gradient: 'linear-gradient(110.85deg, #E9684D -7.61%, #BB321B 113.2%), #EE7A5F',
    name: 'Peach'
  },
  'ripe-mango-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #DBA700 -7.61%, #9C6E00 115.55%), #DEAA04',
    name: 'Mango'
  },
  'tropical-mango-vpro-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #DBA700 -7.61%, #9C6E00 115.55%), #DEAA04',
    name: 'Mango'
  },
  'epen-3-cartridge-indigo-dive': {
    gradient: 'linear-gradient(110.85deg, #7072B5 -7.61%, #7072B5 115.55%), #7072B5',
    name: 'Indigo Dive'
  },
  'epen3-cartridge-scarlet-kick-berries': {
    gradient: 'linear-gradient(110.85deg, #A95A7B -7.61%, #A95A7B 115.55%), #A95A7B',
    name: 'Scarlet Kick'
  },
  'green-snap-epen-3-cartridge': {
    gradient: 'linear-gradient(110.85deg, #0D8787 -7.61%, #0D8787 115.55%), #0D8787',
    name: 'Green Snap'
  },
  watermelon: {
    gradient: 'linear-gradient(116.87deg, #D14441 -7.61%, #F19285 115.55%), #F2968A',
    name: 'Watermelon',
    ontarioTag: 'New',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 2
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  blueberry: {
    gradient: 'linear-gradient(116.87deg, #A296C9 -7.61%, #4D4384 113.2%), #4F4485',
    name: 'Blueberry',
    ontarioTag: 'New',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 4
      },
      {
        label: 'Complexity',
        value: 3
      },
      {
        label: 'Round Body',
        value: 5
      }
    ]
  },
  'lemon-berry': {
    gradient: 'linear-gradient(110.67deg, #FFB3F7 -43.97%, #FFE344 111.93%), #FEDC00',
    name: 'Lemon Berry',
    attributes: [
      {
        label: 'Taste Intensity',
        value: 3
      },
      {
        label: 'Complexity',
        value: 4
      },
      {
        label: 'Round Body',
        value: 3
      }
    ]
  },
  'citrus-gin': {
    gradient: 'linear-gradient(119.52deg, #85AD39 -2.89%, #FFD83F 105.7%)',
    name: 'Citrus Gin',
    refillsTag: 'Limited Edition',
    isLimited: true,
    gradients: {
      explore: 'linear-gradient(72.83deg, #EABF4B -4.7%, #B4BA50 61.03%, #E3B849 115.49%)',
      background: 'linear-gradient(119.52deg, #85AD39 -2.89%, #FFD83F 105.7%)',
      highlight: 'linear-gradient(72.83deg, #EABF4B -4.7%, #DDE460 39.12%, #FFBC0F 115.49%)',
      flavours: 'radial-gradient(97.1% 211.44% at 3.37% 0%, #e4803b 0%, #eab859 100%)',
      relatedProducts: 'radial-gradient(97.1% 211.44% at 3.37% 0%, #E36240 0%, #FCE983 54.69%, #FBA29E 100%)'
    },
    flavourNotes: {
      description: [
        'The flavour is inspired by the kumquat fruit bringing bold and fresh citrus top notes.',
        'The coriander seeds and gin flavours deliver delicate woody touches and notes of spices.',
        'These intricate layers of flavours are finally amplified with orange, mandarin and coriander extracts.'
      ],
      features: [
        {
          label: 'CORIANDER EXTRACT',
          figure: 'coriander'
        },
        {
          label: 'MANDARIN EXTRACT',
          figure: 'mandarin'
        },
        {
          label: 'ORANGE EXTRACT',
          figure: 'orange'
        },
        {
          label: 'vPRO NICOTINE SALT',
          figure: 'vpro'
        }
      ]
    },
    relatedProducts: ['blood-orange-epod-cartridge', 'lemon-berry'],
    attributes: [
      {
        label: 'Taste Intensity',
        value: 5
      },
      {
        label: 'Complexity',
        value: 4
      }
    ]
  },
  'pineapple-melon': {
    gradient: 'linear-gradient(72.83deg, #EABF4B -4.7%, #DDE460 39.12%, #FFBC0F 115.49%)',
    name: 'Pineapple Melon',
    refillsTag: 'Limited Edition',
    isLimited: true,
    gradients: {
      explore: 'linear-gradient(72.83deg, #EABF4B -4.7%, #B4BA50 61.03%, #E3B849 115.49%)',
      background: 'linear-gradient(72.83deg, #EABF4B -4.7%, #B4BA50 61.03%, #E3B849 115.49%)',
      highlight: 'linear-gradient(72.83deg, #EABF4B -4.7%, #DDE460 39.12%, #FFBC0F 115.49%)',
      flavours: 'radial-gradient(97.1% 211.44% at 3.37% 0%, #D1B75C 0%, #FAE069 100%)',
      relatedProducts: 'radial-gradient(97.1% 211.44% at 3.37% 0%, #AD4D86 0%, #FFD673 54.69%, #EA4E51 100%)'
    },
    flavourNotes: {
      description: [
        'The flavour is built around bold pineapple notes with melon touches.',
        'The starfruit flavour brings  delicate tropical and floral nuances to the mix.',
        'Finally, the peppermint extract adds subtle freshness to the taste experience.'
      ],
      features: [
        {
          label: 'PEPPERMINT EXTRACT',
          figure: 'peppermint'
        },
        {
          label: 'vPRO NICOTINE SALT',
          figure: 'vpro'
        }
      ]
    },
    relatedProducts: ['passionfruit', 'epod-mango-wonder-vpro-cartridges', 'strawberry'],
    attributes: [
      {
        label: 'Taste Intensity',
        value: 5
      },
      {
        label: 'Complexity',
        value: 4
      }
    ]
  },
  clear: {
    gradient: 'linear-gradient(115.99deg, #DCDCDC -7.61%, #CCCCCC 113.2%), #D4D4D4',
    name: 'Clear',
    refillsTag: 'New',
    ontarioTag: 'New',
    isDark: true
  },
  'epod-charging-cable': {
    thumbnail: 'images/accessories/charger.jpg'
  },
  'epod-ring': {
    gradients: {
      background: 'linear-gradient(65.82deg, #FEFEFE 0%, #DCDCDC 100%)',
      figureBackground: 'linear-gradient(65.82deg, #DEDEDE 0%, #EDEDED 100%)'
    }
  },
  'pod-caps': {
    thumbnail: 'images/accessories/pod-caps.jpg',
    gradients: {
      background: 'linear-gradient(65.82deg, #FEFEFE 0%, #DCDCDC 100%)',
      figureBackground: 'linear-gradient(65.82deg, #DEDEDE 0%, #EDEDED 100%)'
    }
  },
  'the-pouch': {
    thumbnail: 'images/accessories/pouch.jpg',
    gradients: {
      black: {
        background: 'linear-gradient(70.92deg, #939393 0%, #010101 100%)',
        figureBackground: 'linear-gradient(145.96deg, #101010 7.51%, rgba(239, 239, 239, 0) 113.7%)'
      },
      blue: {
        background: 'linear-gradient(70.92deg, #8B86AE 0%, #342E56 100%)',
        figureBackground: 'linear-gradient(212.53deg, #4B486E 7.19%, rgba(161, 159, 192, 0) 99.79%), #262142'
      },
      red: {
        background: 'linear-gradient(119.98deg, #8B263C 0%, #7B2B3D 100%)',
        figureBackground: 'linear-gradient(119.52deg, #53363D -2.89%, #D51D47 105.7%)'
      }
    },
    isDark: true
  },
  'cherry-red-charger-cable': {
    thumbnail: 'images/accessories/pouch.jpg',
    gradients: {
      'cherry red': {
        background: 'linear-gradient(119.98deg, #8B263C 0%, #7B2B3D 100%)',
        figureBackground: 'linear-gradient(119.52deg, #53363D -2.89%, #D51D47 105.7%)'
      }
    },
    isDark: true,
    isNew: true
  },
  calla: {
    gradient: 'linear-gradient(180deg, #1F081A 0%, #872E5F 100%)'
  },
  cimento: {
    gradient: 'linear-gradient(180deg, #615C5A 0%, #E3E3E3 100%)'
  },
  tweed: {
    gradient: 'linear-gradient(180deg, #F5AA53 0%, #D32D9B 100%)'
  },
  clavo: {
    gradient:
      'linear-gradient(130.43deg, #AE871C -1.45%, #F2C81D 35.96%, #E98E2F 57.21%, #E24F31 77.99%, #DE3535 87.23%)'
  },
  ciel: {
    gradient: 'linear-gradient(143.35deg, #0C4880 5.62%, #0991BB 49.03%, #E3E3E3 101.42%, #53AAB5 101.42%)'
  },
  verde: {
    gradient: 'linear-gradient(128.78deg, #16251D 0.94%, #1CCF1A 24.52%, #75C3D3 58.48%, #C4CC0C 91.49%)'
  }
}

export const ALLOWED_PROVINCES = ['AB', 'BC', 'MB', 'NB', 'NL', 'ON', 'PE', 'SK']

export const CANADIAN_PROVINCES = [
  {
    label: 'Alberta',
    value: 'AB'
  },
  {
    label: 'British Columbia',
    value: 'BC'
  },
  {
    label: 'Manitoba',
    value: 'MB'
  },
  {
    label: 'New Brunswick',
    value: 'NB'
  },
  {
    label: 'Saskatchewan',
    value: 'SK'
  },
  {
    label: 'Ontario',
    value: 'ON'
  },
  {
    label: 'Prince Edward Island',
    value: 'PE'
  },
  {
    label: 'Newfoundland and Labrador',
    value: 'NL'
  },
  {
    label: 'Quebec',
    value: 'QC'
  }
]

export const POSTAL_CODE_START_BY_PROVINCE = {
  AB: ['T'],
  BC: ['V'],
  MB: ['R'],
  NB: ['E'],
  NL: ['A'],
  NT: ['X'],
  NS: ['B'],
  NU: ['X'],
  ON: ['K', 'L', 'M', 'N', 'P'],
  PE: ['C'],
  QC: ['G', 'H', 'J'],
  SK: ['S'],
  YT: ['Y']
}

export const TIERS_TRESHOLDS = {
  silver: 100,
  gold: 250,
  platinum: 400
}

export const TIERS_BENEFITS = {
  silver: ['Free shipping on all orders', 'Birthday gift'],
  gold: ['Free shipping on all orders', 'Birthday gift', '<strong>Early access</strong> to new flavours'],
  platinum: [
    '<strong>Free express shipping</strong> on all orders',
    'Birthday gift',
    '<strong>Early access</strong> to new product and flavours'
  ]
}

export const INITIAL_ENGRAVING = {
  front: {
    pattern: {
      value: '',
      name: '',
      collection: '',
      displayName: 'Pattern',
      slug: 'pattern'
    },
    miniIcon: {
      value: '',
      name: '',
      displayName: 'Mini Icon',
      slug: 'icon'
    },
    text: {
      value: '',
      orientation: 'horizontal',
      font: 'Abebedera',
      displayName: 'Text',
      slug: 'text'
    },
    proceeded: false
  },
  back: {
    text: {
      value: '',
      orientation: 'horizontal',
      font: 'Abebedera',
      displayName: 'Text',
      slug: 'text'
    },
    proceeded: false
  },
  proceeded: false
}

export const ENGRAVING_PATTERNS = [
  {
    collection: 'View all',
    patterns: [
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/lilac.svg`, name: 'Lilac' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/aro.svg`, name: 'Aro' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/rhombus.svg`, name: 'Rhombus' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/cipher.svg`, name: 'Cipher' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/grano.svg`, name: 'Grano' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/lanza.svg`, name: 'Lanza' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/spectro.svg`, name: 'Spectro' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/floreo.svg`, name: 'Floreo' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/spira.svg`, name: 'Spira' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/paso.svg`, name: 'Paso' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/flecha.svg`, name: 'Flecha' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/zona.svg`, name: 'Zona' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/hoya.svg`, name: 'Hoya' },
      { value: `${process.env.BASE_PATH}/images/engraving/patterns/nami.svg`, name: 'Nami' }
    ]
  }
]

export const SUBSCRIPTION_SHIPPING_METHODS = {
  kwiksave: {
    label: 'Kwiksave',
    description: 'Express shipping through Kwiksave'
  },
  fedex: {
    label: 'FedEx',
    description: 'Express shipping through Fedex'
  },
  canpost_standard: {
    label: 'Canada Post Standard',
    description: 'Standard shipping through Canada Post'
  },
  canpost_express: {
    label: 'Canada Post Express',
    description: 'Express shipping through Canada Post'
  }
}

export const ENGRAVING_MINI_ICONS = [
  {
    collection: 'View all',
    icons: [
      { value: `${process.env.BASE_PATH}/images/engraving/icons/berg.svg`, name: 'Berg' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/bolt.svg`, name: 'Bolt' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/brella.svg`, name: 'Brella' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/costo.svg`, name: 'Costo' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/equinox.svg`, name: 'Equinox' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/flor.svg`, name: 'Flor' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/pluma.svg`, name: 'Pluma' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/shoku.svg`, name: 'Shoku' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/anana.svg`, name: 'Anana' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/radial.svg`, name: 'Radial' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/mousa.svg`, name: 'Mousa' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/centro.svg`, name: 'Centro' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/brilla.svg`, name: 'Brilla' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/kuro.svg`, name: 'Kuro' },
      { value: `${process.env.BASE_PATH}/images/engraving/icons/tido.svg`, name: 'Tido' }
    ]
  }
]

export const PAGE_TYPES = {
  '/404': '404',
  '/': 'home',
  '/account/': 'account',
  '/account/orders/': 'account',
  '/account/rewards/': 'account',
  '/account/savings/': 'account',
  '/account/subscriptions/': 'account',
  '/benefits/': 'other',
  '/cart/': 'cart',
  '/challenge/': 'other',
  '/checkout/': 'checkout',
  '/vuse-epod-2/': 'plp',
  '/vape-stores/': 'other',
  '/pass-on-the-savings/': 'support',
  '/subscribe/': 'other',
  '/pages/privacy-policy/': 'support',
  '/pages/conditions-of-sale/': 'support',
  '/pages/cookie-policy/': 'support',
  '/pages/subscription-terms-and-conditions/': 'support',
  '/pages/terms-conditions/': 'support',
  '/pages/savings-terms-and-conditions/': 'support',
  '/buy-online/epod-starter-bundle/': 'pdp',
  '/buy-online/epen-3/': 'plp',
  '/buy-online/the-pouch/': 'pdp',
  '/buy-online/engravable/': 'pdp',
  '/buy-online/vype-epod-accessories/': 'plp',
  '/buy-online/vype-epod-vpro-cartridges/epod-mango-wonder-vpro-cartridges/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/creamy-mint/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/smooth-tobacco/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/rich-tobacco/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/infused-cucumber-epod-cartridge/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/blueberry/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/peach/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/strawberry/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/epod-nicotine-salts-vanilla/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/epod-nicotine-salts-golden-tobacco-vpro-cartridges/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/watermelon/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/passionfruit/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/blood-orange-epod-cartridge/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/lemon-berry/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/epod-vpro-cartridges-polar-mint/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/lychee/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/clear/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/citrus-gin/': 'pdp',
  '/buy-online/vype-epod-vpro-cartridges/pineapple-melon/': 'pdp',
  '/buy-online/vype-epod-skins/': 'plp',
  '/buy-online/vype-epod-skins/serpa/': 'pdp',
  '/buy-online/vype-epod-skins/curo/': 'pdp',
  '/buy-online/vype-epod-skins/glacia/': 'pdp',
  '/buy-online/vype-epod-skins/orna/': 'pdp',
  '/buy-online/vype-epod-skins/plate/': 'pdp',
  '/buy-online/vype-epod-skins/glow-in-the-dark/': 'pdp',
  '/buy-online/vype-epod-skins/halftone/': 'pdp',
  '/buy-online/vype-epod-skins/umbra/': 'pdp',
  '/buy-online/vype-epod-skins/fabrica/': 'pdp',
  '/buy-online/vype-epod-skins/foil/': 'pdp',
  '/buy-online/vype-epod-skins/marmor/': 'pdp',
  '/buy-online/vype-epod-skins/sway/': 'pdp',
  '/buy-online/vype-epod-skins/tikiti/': 'pdp',
  '/buy-online/vype-epod-skins/vesper/': 'pdp',
  '/buy-online/vype-epod-skins/tingo/': 'pdp',
  '/buy-online/vype-epod-skins/vastus/': 'pdp',
  '/buy-online/multipack-3/': 'pdp',
  '/buy-online/multipack-5/': 'pdp',
  '/buy-online/epod-charging-cable/': 'pdp',
  '/buy-online/epod-devices/': 'pdp',
  '/buy-online/vype-epen-3-cartridges/': 'plp',
  '/buy-online/vype-epod-vpro-cartridges': 'plp',
  '/buy-online/vype-epod-vpro-cartridges/': 'plp',
  '/buy-online/vuse-pods/': 'plp',
  '/buy-online/epod-ring/': 'pdp',
  '/buy-online/liquid-colour-collection/': 'pdp',
  '/vuse-plus-vape-deals/': 'support',
  '/order-confirmation/': 'confirmation',
  '/vusebyu/': 'other'
}

export const ALLOWED_BUYFLOW_ROUTES = [
  'epod',
  'epen-3',
  'epod-devices',
  'engravable',
  'epod-starter-kit',
  'limited-edition-box-sets',
  'limited-edition-epod'
]

export const PATHS_WITHOUT_SOFT_AV = ['/account/email-verification', '/create-password', '/qc']

export const OOS_QTY_THRESHOLD = 10 // If the quantity for a variant in a province is less than this constant, we mark it as out of stock
